// ------------------------------------
// Import SCSS files
// ------------------------------------

import "../sass/base.scss";
jQuery(document).ready(function($) {
    $('#menu-primary > li > a').each(function() {
        const linkHref = $(this).attr('href');

        if (this.href === window.location.href) {
            $(this).addClass('active');
        }
    });
});

